import React, { useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
// import NepaliDate from "nepali-date";
import NepaliDate from "nepali-date-converter";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const TopCalendar = () => {
  const lang = React.useContext(LangContext);
  const nep = lang.state.np;

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer); // cleanup on unmount
  }, []);

  const DaysEnglish = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const DaysNepali = [
    "आइतबार",
    "सोमबार",
    "मङ्गलबार",
    "बुधवार",
    "बिहीबार",
    "शुक्रबार",
    "शनिबार",
  ];

  const dayName = DaysEnglish[currentTime.getDay()];
  const dayNameNepali = DaysNepali[currentTime.getDay()];

  const englishFormat = `${currentTime.toLocaleString("default", {
    month: "long",
  })} ${currentTime.getDate()}, ${currentTime.getFullYear()}`;
  const EnglishDate = `${englishFormat} ${dayName}`;

  const nepaliDate = new NepaliDate(currentTime);
  const formattedNepaliDate = nepaliDate.format("MMMM D, YYYY");
  // console.log("Nepali Date:", formattedNepaliDate);
  const NePaliDate = `${formattedNepaliDate} ${dayNameNepali}`;

  const time = currentTime.toLocaleTimeString();

  return (
    <>
      <AccessTimeIcon fontSize="small" />
      <span>{time}</span>
      <CalendarMonthIcon fontSize="small" />
      <span>{nep ? NePaliDate : EnglishDate}</span>
    </>
  );
};

export default TopCalendar;
